import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

export default  new Vuex.Store({
    state: {
        user: null,
        date: null,
        
    },
    mutations : {
        user (state, data) {
            state.user = data
        },
        date(state, data){
            state.date = data
        }
    },
    actions : {
        
    },
    getters : { 
        user(state ){
            return state.user
        },
        date(state){
            return state.date
        }
    },
    plugins: [createPersistedState()]
})



// WEBPACK FOOTER //
// ./src/vuex/store.js